import {Cureus} from '../Cureus';

Cureus.HumanSubjects = {};

//= require_tree ./HumanSubjects